import { isMobile, isMobileSafari, isIOS } from 'react-device-detect';

export default initData => {
    const {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        isHybridAppContext,
        isNativeAppContext,
        isSinglePageApp,
        splitTests,
        splitTestGroups,
        version,
        environmentHash
    } = initData;
    return {
        debug,
        discoverEnabled,
        environment,
        enableTimeMetrics,
        enableFastClick,
        featureSwitches,
        environmentHash,
        isHybridAppContext,
        isInIframe: window.frameElement ? true : false,
        isIOS,
        isNativeAppContext,
        isMobileDevice: isMobile,
        isMobileSafari,
        isSpaNavigationEnabled:
            isSinglePageApp && !isHybridAppContext && !window.frameElement
                ? true
                : false, // No SPA navigation in native apps or iFrame
        splitTests,
        splitTestGroups,
        version
    };
};
